import Helper from './Helper';

class SideNav {
  constructor(config = {}) {
    const {
      sideNavTitles
    } = config;

    this.sidenav = document.querySelector('.sidenav__inner');

    if (!!this.sidenav) {
      this.sideNavTitles = Array.prototype.slice.call(document.querySelectorAll(sideNavTitles));

      if (this.sideNavTitles.length >= 1) {
        this.generateSideNav();
      }
    }
  }

  generateSideNav() {
    let html = '';
    let keyItems = 0;
    let index = 0;
    html += '<div class="sidenav__content">'
    this.sideNavTitles.forEach(title => {
      title.dataset.index = index;
      html += `<a class="sidenav__item" data-index="${index}" href="#">`
      html += `<span class="sidenav__text">${title.innerHTML}</span>`
      html += `<span class="sidenav__dot"></span>`
      html += '</a>'
      index++;
    });
    html += '</div>'
    this.sidenav.innerHTML = html;

    this.sideNavItems = Array.prototype.slice.call(document.querySelectorAll('.sidenav__item'))

    this.bindLinks();
    this.scrollSpy();
  }

  bindLinks() {
    this.sideNavItems.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        this.setItemActive(item);
        this.scrollTo(this.sideNavTitles[item.dataset.index]);
      })
    });
  }

  scrollSpy() {
    let lastIndex = 0;
    let lastScroll = 0;
    const maxItems = this.sideNavItems.length;
    let index = this.getIndex();
    this.setItemActive(this.sideNavItems[index]);

    document.addEventListener("scroll", () => {
      const firstVisisble = this.getIndex();

      if (firstVisisble >= 0 && firstVisisble != index) {
        this.setItemActive(this.sideNavItems[firstVisisble]);
        index = firstVisisble;
      }
    });
  }

  getIndex() {
    let index = 0;

    let firstVisisble = [...this.sideNavTitles].findIndex(item => Helper.isInViewport(item));
    if (firstVisisble >= 0) {
      return firstVisisble;
    }

    firstVisisble = [...this.sideNavTitles].filter(nav => {
      const bounding = nav.getBoundingClientRect();
      return bounding.top <= 0;
    });

    if(firstVisisble.length > 0) {
      return firstVisisble.length -1;
    }

    return index;
  }

  setItemActive(item) {
    this.sideNavItems.forEach(i => {
      i.classList.remove('active');
    })
    item.classList.add('active');
  }

  scrollTo(element) {
    window.scroll({
      behavior: 'smooth',
      left: 0,
      top: Helper.getRealOffsetTop(element) - 100
    });
  }

}

export default SideNav;
